<script lang="ts">
import {defineComponent} from "vue";
import {LoadingType} from "@/type/LoadingType";

export default defineComponent({
  name: 'LoadingIcon',
  computed: {
    LoadingType() {
      return LoadingType
    }
  },

  props: {
    type: {
      type: String,
      default: LoadingType.LARGE
    }
  }
})
</script>

<template>
  <div class="d-flex align-items-center justify-content-center h-100 w-100 m-0" :data-spiner="type">
    <div class="dots-animation" v-if="type === LoadingType.DOTS"/>
    <div class="loading-spinner" v-else></div>
  </div>
</template>

<style scoped lang="scss">
[data-spiner="small"] {
  .loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-left: 2px solid #FFF;
  }
}

[data-spiner="large"] {
  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.1);
    border-left: 4px solid #FFF;
  }
}

.dots-animation {
  display: inline-block;
  position: relative;
  width: 100%;
  font-size: 20px;
}

.dots-animation::before {
  content: '.';
  animation: dots 1.4s infinite steps(4, start);
}

.loading-spinner {
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes dots {
  0%, 33% {
    content: '.';
  }
  34%, 66% {
    content: '..';
  }
  67%, 100% {
    content: '...';
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>